import { httpV1 as http } from '../api';

export async function createAgenda(data) {
  return http.post(
    '/fgts/batch-balance-scheduling',
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
}

export async function checkAgenda() {
  return http.get('/fgts/batch-balance-scheduling/check');
}

export async function fetchAgendas() {
  return http.get('/fgts/batch-balance-scheduling');
}

export async function deleteAgenda(agenda_id) {
  return http.delete(`/fgts/batch-balance-scheduling/${agenda_id}`);
}

export async function exportResultToCSV(id) {
  return http.get(`/fgts/batch-balance-scheduling/${id}/export`);
}

export async function getUnreadNotification() {
  return http.get('/fgts/batch-balance-scheduling/notifications/unread');
}

export async function markNotificationRead(id) {
  return http.patch(`/fgts/batch-balance-scheduling/${id}/notification-read`);
}
